    <div class="row community-post-container">
        <div class="col-md-4 pr-md-0">


            <div class="pb-2" *ngIf="topicList?.length > 0">
                <div class="bg-white rounded-corners-12 mb-2 py-2 container-shadow">
                    <div class="px-3 pt-2 pb-3">
                        <span class="heading-4">
                            <span class="color-grey-700"> {{mls.languageText.community.key174}}</span> 
                        </span>
                        <img class="filter-width" *ngIf="isMobile"  src="assets/images/filter_icon.svg" alt="filter icon" >
                        <span *ngIf="isMobile" (click)="showTopic(i)" class="float-right cursor-pointer">
                            <img *ngIf="!topicActiveState" src="assets/images/events/down-arrow.svg" alt="down arrow">
                            <img *ngIf="topicActiveState" src="assets/images/events/up-arrow.svg" alt="up arrow">
                        </span>
                    </div>
                    <div class="px-3 unordered-list"  *ngIf="topicActiveState && isMobile || isMobile === false">
                        <ul>
                            <li class="w-100" *ngFor="let fitem of topicList; let i=index;">
                              <label class="list-item radio w-100">
                                <input type="radio" 
                                    name="list-for" 
                                    [checked]="fitem?.code === ''"  
                                    [value]="fitem?.code"  
                                    [name]="'name'" 
                                    (change)="getPostsByFilter('topic', fitem.code);" />
                                <span class="paragraph-bold">{{fitem?.name}}</span>
                              </label>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>


            <div class="pb-2" *ngFor="let fitem of postedByFilterData?.filter; let i=index;">
                <div class="bg-white rounded-corners-12 mb-2 py-2 container-shadow">
                    <div class="px-3 pt-2 pb-3">
                        <span class="heading-4">
                            <span class="color-grey-700">{{fitem?.tab_name}}</span> 
                        </span>
                        <img class="filter-width" *ngIf="isMobile"  src="assets/images/filter_icon.svg" alt="filter icon" >
                        <span *ngIf="isMobile" (click)="showFilter(i)" class="float-right cursor-pointer">
                            <img *ngIf="!fitem['activeState']" src="assets/images/events/down-arrow.svg" alt="down arrow">
                            <img *ngIf="fitem['activeState']" src="assets/images/events/up-arrow.svg" alt="up arrow">
                        </span>
                    </div>
                    <div class="px-3 unordered-list" *ngIf="fitem['activeState'] && isMobile || isMobile === false">
                        <ul>
                            <li class="w-100" *ngFor="let posts of postedByFilterData?.filter[i]['list']">
                              <label class="list-item radio w-100">
                                <input type="radio" 
                                    name="list-for" 
                                    [checked]="posts?.value === ''"  
                                    [value]="posts?.value" 
                                    [name]="fitem?.key" 
                                    (change)="getPostsByFilter(fitem?.key, posts);" />
                                <span class="paragraph-bold">{{posts?.name}}</span>
                              </label>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>


        </div>
        <div class="col-md-8">
            <app-community-posts-filter-feed 
                [postDataLoader]="postDataLoader" 
                [postDataByFilter]="postDataByFilter" 
                [postOffSet]="postOffSet" 
                (setPostDataOffset)="setPostDataOffset($event)"
                (emitReloadFeed)="reloadFeed($event)"
                [isCommunityAdmin]="isCommunityAdmin">
            </app-community-posts-filter-feed>
        </div>
    </div>